import { FC } from 'react';
import styled, { css } from 'styled-components';

import media from '../../../utils/styling/media';
import ActionBar, { ActionBarProps } from '../ActionBar';

export const StyledActionBar = styled<FC<ActionBarProps & {align?: string}> >(ActionBar)`
  justify-content: ${({ theme }) => theme?.ConfirmBar?.justifyContent};
  
  ${({ align }) => align === 'center' && `
    justify-content: center;
  `}

  ${media.xs`
    ${({ theme }) => (theme?.ConfirmBar?.flexDirection === 'row-reverse') && `
      flex-direction: column-reverse;
    `}

    > * {
        flex: 1;
        min-width: calc(100% - 32px);
      }
  `}

  ${media.sm`
    flex-direction: ${({ theme }) => theme?.ConfirmBar?.flexDirection};

    > * {
      min-width: auto;
    }
  `}

  ${media.sm`
    ${({ theme }) => theme?.ConfirmBar?.flexButtons === false && css`
      > * {
        flex: 0;
      }
    `};
  `}
`;
